<template>
  <div class="bg-icssilver-50 bg-hero-current-icssilver-100">
    <slot />
  </div>
</template>
